angular.module('unica_media_directory.media_directory_controllers')

.controller('MediaDirectoryEditController', function(
	$rootScope, $scope, $state, $stateParams,
	MediaDirectoryEditService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventStages( $stateParams.event_id );


	$rootScope.getMediaDirectory( $stateParams.id );

	$scope.pageTitle = 'Modifica Directory';

	$rootScope.mediaDirectoryData = {
		event_id: $stateParams.event_id,
		title: ''
	};

	$scope.saveMediaDirectory = function() {
		$scope.showLoader();

		var mediaDirectoryData = angular.copy($rootScope.mediaDirectoryData);

		MediaDirectoryEditService
			.update(mediaDirectoryData)
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Media Directory aggiornata con successo!', '');
					$state.go('app.media_directory.list', { event_id: $stateParams.event_id });
				} else {
					$rootScope.manageError(data);
				}
			});
	};

})

;